export let notes = [
    {
        title: "Hard/dry dates",
        text: "If your dates are hard and dry, I recommend soaking them in warm water for 10-15 minutes to soften. Just drain them well before using."
    },
    {
      title: "Coconut oil",
      text: "This is used to help make the melted chocolate thinner, which makes it easier to dip the Samoas. The coconut oil also helps harden the chocolate in the freezer. You can skip it, but your melted chocolate will likely be pretty thick. I recommend using refined coconut oil if you don’t want any coconut flavor!"
    }
]